export interface IPerformToggleData {
    active: Set<string>
}

export function parsePerformToggleData(data?: string): IPerformToggleData {
    return {
        active: data ? new Set(data.split(",")) : new Set<string>(),
    }
}
